<template>
  <div class="upload-list">
    <slot />
  </div>
</template>
<script>
export default {
  name: "UploadList",
};
</script>
<style lang="scss">
@import "@/assets/scss/component/upload-list";
</style>